jQuery( document ).ready(function($) {
  
  //new code added for accessibility reasons
  
  //make the wishlist button in header visible; Background color of page vanishes it
  let wishlistSvgComponent = document.getElementById("D.-Account----Orders")
  wishlistSvgComponent.setAttribute("fill", "#e0e1d9")
  
  //get all elements by classname "focus-inset"
  let focusElements = document.getElementsByClassName("focus-inset")
  for(let i=0; i<focusElements.length; i++){
    focusElements[i].classList.add("focus-inset-press")
  }

    //alert("dd")

    $(".press_block .view_all_btn").off().on("click", function(e) {

        $(this).parent().toggleClass("display_show_more");
      
        $(this).hide();

        document.getElementById("element_after_view_all").focus();
    });
  
});